import { render, staticRenderFns } from "./ProjectWebsites.vue?vue&type=template&id=f5676978"
import script from "./ProjectWebsites.vue?vue&type=script&lang=ts"
export * from "./ProjectWebsites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports